import http from "@/utils/http";

export function AdminInfo(params){
    return  http({
        url: "admin/info",
        method: "get",
        params: params
    })
}

export function AdminList(params){
    return http({
        url: "admin/list",
        method: "get",
        params: params
    })
}

export function AdminMenu(params){
    return http({
        url: "admin/menu",
        method: "get",
        params: params
    })
}

export function AdminAdd(params){
    return http({
        url: "admin/add",
        method: "post",
        data: params
    })
}

export function AdminSystem(params){
    return http({
        url: "admin/system",
        method: "post",
        data: params
    })
}

export function AdminProxy(params){
    return http({
        url: "admin/proxy",
        method: "post",
        data: params
    })
}

export function AdminEdit(params){
    return http({
        url: "admin/edit",
        method: "post",
        data: params
    })
}

export function AdminStatus(params){
    return http({
        url: "admin/status",
        method: "post",
        data: params
    })
}

export function AdminDelete(params){
    return http({
        url: "admin/delete",
        method: "post",
        data: params
    })
}
